import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';

/**
 * Hook that returns placeholder text for the project selector based on selected teams
 *
 * @returns {string} Placeholder text to display:
 *  - If no teams selected: First team name or "Select Project" translation
 *  - If one team selected: Selected team name or "1 Project" translation
 *  - If multiple teams selected: Translation with count of selected teams
 */
const usePlaceholderText = (): string => {
  const { t } = useTranslation();
  const teams = useGlobalStore((state) => state.teams);
  const selectedTeamIds = useProcessAnalysisStore((state) => state.selectedTeams);

  if (selectedTeamIds.length === 0) {
    // Show first team by default
    const defaultTeam = teams[0];
    return defaultTeam?.name || t('process_analysis.main_section.select_project');
  }

  if (selectedTeamIds.length === 1) {
    const team = teams.find((p: any) => p.id === selectedTeamIds[0]);
    return team?.name || t('process_analysis.main_section.one_project');
  }

  return t('process_analysis.main_section.multiple_projects', { count: selectedTeamIds.length });
};

export { usePlaceholderText };
